import { AUCTION_TYPES } from 'constants';
import { EntityWithCount } from 'services/api/types';
import { Vehicle } from 'types/vehicle';

export const useGetAaVehicleIds = (vehicles: EntityWithCount<Vehicle> | undefined) => {
  return (
    vehicles?.rows?.ids?.filter(id => vehicles?.rows?.entities?.[id]?.auction?.type === AUCTION_TYPES.AUTOAXESS) || []
  );
};
